export class AppSettings {
    public title: string = "";
    public version: string = "";
    public showNav: boolean = true;
    public showFooter: boolean = true;
    public supportLink: string = "";
    public user: any = null;
    public roles: any = null;
}
